var map = {
	"./components/CurrencyInput": 6,
	"./components/CurrencyInput.tsx": 6,
	"./components/DataTable": 2,
	"./components/DataTable.tsx": 2,
	"./components/data-table/Cell": 19,
	"./components/data-table/Cell.tsx": 19,
	"./components/data-table/FooterRow": 37,
	"./components/data-table/FooterRow.tsx": 37,
	"./components/data-table/HeaderRow": 38,
	"./components/data-table/HeaderRow.tsx": 38,
	"./components/data-table/TaxAssumptionsHeaderRow": 39,
	"./components/data-table/TaxAssumptionsHeaderRow.tsx": 39,
	"./components/data-table/cell-formats/Money": 217,
	"./components/data-table/cell-formats/Money.tsx": 217,
	"./components/opening-balance-sheet/AdditionalFieldsCard": 40,
	"./components/opening-balance-sheet/AdditionalFieldsCard.tsx": 40,
	"./components/opening-balance-sheet/CreditorRow": 41,
	"./components/opening-balance-sheet/CreditorRow.tsx": 41,
	"./components/opening-balance-sheet/CreditorsTable": 42,
	"./components/opening-balance-sheet/CreditorsTable.tsx": 42,
	"./components/opening-balance-sheet/CurrentAssetsCard": 43,
	"./components/opening-balance-sheet/CurrentAssetsCard.tsx": 43,
	"./components/opening-balance-sheet/CurrentLiabilitiesCard": 46,
	"./components/opening-balance-sheet/CurrentLiabilitiesCard.tsx": 46,
	"./components/opening-balance-sheet/DebtorRow": 45,
	"./components/opening-balance-sheet/DebtorRow.tsx": 45,
	"./components/opening-balance-sheet/DebtorsTable": 44,
	"./components/opening-balance-sheet/DebtorsTable.tsx": 44,
	"./components/opening-balance-sheet/ExistingLoanRow": 48,
	"./components/opening-balance-sheet/ExistingLoanRow.tsx": 48,
	"./components/opening-balance-sheet/ExistingLoansTable": 47,
	"./components/opening-balance-sheet/ExistingLoansTable.tsx": 47,
	"./components/opening-balance-sheet/FixedAssetCategorySelect": 55,
	"./components/opening-balance-sheet/FixedAssetCategorySelect.tsx": 55,
	"./components/opening-balance-sheet/FixedAssetRow": 49,
	"./components/opening-balance-sheet/FixedAssetRow.tsx": 49,
	"./components/opening-balance-sheet/FixedAssetsCard": 50,
	"./components/opening-balance-sheet/FixedAssetsCard.tsx": 50,
	"./containers/DividendsDataTable": 220,
	"./containers/DividendsDataTable.tsx": 220,
	"./containers/EquityDataTable": 221,
	"./containers/EquityDataTable.tsx": 221,
	"./containers/OpeningBalanceSheet": 222,
	"./containers/OpeningBalanceSheet.tsx": 222,
	"./containers/OtherCreditorsDataTable": 223,
	"./containers/OtherCreditorsDataTable.tsx": 223,
	"./containers/OtherDebtorsDataTable": 224,
	"./containers/OtherDebtorsDataTable.tsx": 224,
	"./containers/OtherIncomeDataTable": 225,
	"./containers/OtherIncomeDataTable.tsx": 225,
	"./containers/OverdraftLimitsDataTable": 226,
	"./containers/OverdraftLimitsDataTable.tsx": 226,
	"./containers/OverheadDaysToPayDataTable": 227,
	"./containers/OverheadDaysToPayDataTable.tsx": 227,
	"./containers/OverheadsDataTable": 228,
	"./containers/OverheadsDataTable.tsx": 228,
	"./containers/PaymentTermsDataTable": 229,
	"./containers/PaymentTermsDataTable.tsx": 229,
	"./containers/SalariesDataTable": 230,
	"./containers/SalariesDataTable.tsx": 230,
	"./containers/SalesDataTables": 231,
	"./containers/SalesDataTables.tsx": 231,
	"./containers/StockDaysToPayDataTable": 232,
	"./containers/StockDaysToPayDataTable.tsx": 232,
	"./containers/StocksDataTable": 233,
	"./containers/StocksDataTable.tsx": 233,
	"./containers/SupplierDaysToPayDataTable": 234,
	"./containers/SupplierDaysToPayDataTable.tsx": 234,
	"./containers/TaxAssumptionsDataTable": 235,
	"./containers/TaxAssumptionsDataTable.tsx": 235,
	"./containers/sales/GrossProfitDataTable": 53,
	"./containers/sales/GrossProfitDataTable.tsx": 53,
	"./containers/sales/MarginDataTable": 52,
	"./containers/sales/MarginDataTable.tsx": 52,
	"./containers/sales/SalesDataTable": 54,
	"./containers/sales/SalesDataTable.tsx": 54,
	"./modules/datatables/api": 7,
	"./modules/datatables/api.ts": 7,
	"./modules/dividends/api": 26,
	"./modules/dividends/api.ts": 26,
	"./modules/equity/api": 27,
	"./modules/equity/api.ts": 27,
	"./modules/opening-balance-sheet/api": 28,
	"./modules/opening-balance-sheet/api.ts": 28,
	"./modules/opening-balance-sheet/interface-converter": 29,
	"./modules/opening-balance-sheet/interface-converter.ts": 29,
	"./modules/opening-balance-sheet/types": 12,
	"./modules/opening-balance-sheet/types.ts": 12,
	"./modules/other-creditors/api": 22,
	"./modules/other-creditors/api.ts": 22,
	"./modules/other-debtors/api": 23,
	"./modules/other-debtors/api.ts": 23,
	"./modules/other-income/api": 30,
	"./modules/other-income/api.ts": 30,
	"./modules/overdraft/api": 31,
	"./modules/overdraft/api.ts": 31,
	"./modules/overheads/api": 17,
	"./modules/overheads/api.ts": 17,
	"./modules/overheads/types": 236,
	"./modules/overheads/types.ts": 236,
	"./modules/payment-terms/api": 51,
	"./modules/payment-terms/api.ts": 51,
	"./modules/products/api": 10,
	"./modules/products/api.ts": 10,
	"./modules/products/types": 237,
	"./modules/products/types.ts": 237,
	"./modules/salaries/api": 32,
	"./modules/salaries/api.ts": 32,
	"./modules/salaries/types": 238,
	"./modules/salaries/types.ts": 238,
	"./modules/sales/api": 16,
	"./modules/sales/api.ts": 16,
	"./modules/sales/types": 239,
	"./modules/sales/types.ts": 239,
	"./modules/stocks/api": 18,
	"./modules/stocks/api.ts": 18,
	"./modules/tax-assumptions/api": 20,
	"./modules/tax-assumptions/api.ts": 20,
	"./utils/csrf": 36,
	"./utils/csrf.ts": 36,
	"./utils/dates": 21,
	"./utils/dates.ts": 21,
	"./utils/http": 4,
	"./utils/http.ts": 4,
	"./utils/uuid": 13,
	"./utils/uuid.ts": 13
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;